import { styled } from '@porsche-code/kado-styled-system/jsx';
import {
  PButtonPure,
  PButtonPureProps,
  PIcon,
  PIconProps,
} from '@porsche-design-system/components-react';
import { SortDirection } from '@tanstack/react-table';

const SortIcon = styled(PIcon, {
  base: {
    marginLeft: 'sm',
    opacity: 0,
    transition: 'opacity var(--durations-sm) var(--easings-base)',
  },

  variants: {
    isActive: {
      true: {
        opacity: 1,
      },
    },
  },
});

const SortButton = styled(PButtonPure, {
  base: {
    fontWeight: 'bold',

    '& > span': {
      fontWeight: 600,
    },

    '&:hover [data-part="sort-icon"]': {
      opacity: 1,
    },
  },
});

export const TableHeadFilter = styled('div', {
  base: {
    display: 'inline-block',
    marginLeft: 'sm',
  },
});

export const TableHeadSortButton = ({
  children,
  direction = 'asc',
  isActive,
  ...props
}: Omit<PButtonPureProps, 'type'> & {
  direction?: SortDirection;
  isActive?: boolean;
}) => {
  const iconName: Record<SortDirection, PIconProps['name']> = {
    asc: 'arrow-up',
    desc: 'arrow-down',
  };

  return (
    <SortButton {...props} type="button" role="button" icon="none" size="xs">
      <span>{children}</span>
      <SortIcon
        data-part="sort-icon"
        isActive={isActive}
        name={iconName[direction]}
        size="xs"
      />
    </SortButton>
  );
};
